import { AcVi00 } from '../controllers/ac-vi00.component';
import { AcVi01 } from '../controllers/ac-vi01.component';
import { AcVi99 } from '../controllers/ac-vi99.component';
import { AvVi01 } from '../controllers/av-vi01.component';
import { AvVi03 } from '../controllers/av-vi03.component';
import { ExVi01 } from '../controllers/ex-vi01.component';
import { ExVi02 } from '../controllers/ex-vi02.component';
import { ExVi03 } from '../controllers/ex-vi03.component';
import { ExVi04 } from '../controllers/ex-vi04.component';
import { ExVi05 } from '../controllers/ex-vi05.component';
import { ExVi06 } from '../controllers/ex-vi06.component';
import { ExVi07 } from '../controllers/ex-vi07.component';
import { ExVi08 } from '../controllers/ex-vi08.component';
import { ExVi09 } from '../controllers/ex-vi09.component';
import { ExVi10 } from '../controllers/ex-vi10.component';
import { ExVi11 } from '../controllers/ex-vi11.component';
import { ExVi12 } from '../controllers/ex-vi12.component';
import { ExVi13 } from '../controllers/ex-vi13.component';
import { ExVi14 } from '../controllers/ex-vi14.component';
import { ExVi15 } from '../controllers/ex-vi15.component';
import { ExVi16 } from '../controllers/ex-vi16.component';
import { ExVi17 } from '../controllers/ex-vi17.component';
import { ExVi18 } from '../controllers/ex-vi18.component';
import { ExVi20 } from '../controllers/ex-vi20.component';
import { ExVi21 } from '../controllers/ex-vi21.component';
import { PaVi01 } from '../controllers/pa-vi01.component';
import { PaVi02 } from '../controllers/pa-vi02.component';
import { PaVi03 } from '../controllers/pa-vi03.component';
import { PaVi04 } from '../controllers/pa-vi04.component';
import { PaVi05 } from '../controllers/pa-vi05.component';
import { PaVi06 } from '../controllers/pa-vi06.component';
import { SgVi01 } from '../controllers/sg-vi01.component';
import { SgVi02 } from '../controllers/sg-vi02.component';
import { SgVi03 } from '../controllers/sg-vi03.component';
import { SgVi04 } from '../controllers/sg-vi04.component';
import { AvVi05 } from '../controllers/av-vi05.component';
import { SgVi05 } from '../controllers/sg-vi05.component';
import { AvVi11 } from '../controllers/av-vi11.component';
import { AvVi13 } from '../controllers/av-vi13.component';
import { AvVi12 } from '../controllers/av-vi12.component';
import { AvVi14 } from '../controllers/av-vi14.component';
import { SgVi06 } from '../controllers/sg-vi06.component';
import { InVi01 } from '../controllers/in-vi01.component';
import { AvVi15 } from '../controllers/av-vi15.component';




export class ControllerSpecificationService {

  private views = {
    'AC_VI00': AcVi00,
    'AC_VI01': AcVi01,
    'AC_VI99': AcVi99,
    'AV_VI01': AvVi01,
    'AV_VI03': AvVi03,
    'EX_VI01': ExVi01,
    'EX_VI02': ExVi02,
    'EX_VI03': ExVi03,
    'EX_VI04': ExVi04,
    'EX_VI05': ExVi05,
    'EX_VI06': ExVi06,
    'EX_VI07': ExVi07,
    'EX_VI08': ExVi08,
    'EX_VI09': ExVi09,
    'EX_VI10': ExVi10,
    'EX_VI11': ExVi11,
    'EX_VI12': ExVi12,
    'EX_VI13': ExVi13,
    'EX_VI14': ExVi14,
    'EX_VI15': ExVi15,
    'EX_VI16': ExVi16,
    'EX_VI17': ExVi17,
    'EX_VI18': ExVi18,
    'EX_VI20': ExVi20,
    'EX_VI21': ExVi21,
    'SG_VI01': SgVi01,
    'SG_VI02': SgVi02,
    'SG_VI03': SgVi03,
    'PA_VI01': PaVi01,
    'PA_VI02': PaVi02,
    'PA_VI03': PaVi03,
    'PA_VI04': PaVi04,
    'PA_VI05': PaVi05,
    'PA_VI06': PaVi06,
    'SG_VI04': SgVi04,
    'AV_VI05': AvVi05,
    'SG_VI05': SgVi05,
    'AV_VI11': AvVi11,
    'AV_VI13': AvVi13,
    'AV_VI12': AvVi12,
    'AV_VI14': AvVi14,
    'SG_VI06': SgVi06,
    'IN_VI01': InVi01,
    'AV_VI15': AvVi15
  };

  getView(view) {
    return this.views[view];
  }

  getViews() {
    return this.views;
  }

}

